import { useAppSelector } from 'common/hooks/redux'

import { MetabaseDashboard } from './MetabaseDashboard'

export const MetabaseCampaignOverview = () => {
  const dashboardId = process.env.REACT_APP_METABASE_CAMPAIGN_DASHBOARD_ID

  const campaignData = useAppSelector(
    (state) => state.campaignStates?.campaignData
  )

  const campaignId = campaignData?._id

  let metric = campaignData?.campaign_data?.bandit_data?.optimization_metric
  if (!metric) {
    metric =
      campaignData?.campaign_data?.bandit_data?.performance_metric?.split(
        '-'
      )[0]
  }
  if (metric === 'clicks' || metric === 'opens') {
    metric = `num_${metric}`
  } else if (metric === 'direct_open' || metric === 'influenced_open') {
    metric = `${metric}s`
  }

  if (!dashboardId) {
    // eslint-disable-next-line no-console
    console.error('Dashboard ID not configured')
    return (
      <div className="flex h-full items-center justify-center p-10">
        <div className="rounded bg-coolGray-50 p-6 text-base-700">
          Unable to load campaign overview. Please contact support.
        </div>
      </div>
    )
  }

  const additionalParams = campaignId
    ? { campaign_name: campaignId, ...(metric ? { metric } : {}) }
    : undefined

  return (
    <MetabaseDashboard
      dashboardId={dashboardId}
      additionalParams={additionalParams}
    />
  )
}
